/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentTypeLightResponse } from './AppointmentTypeLightResponse';
import {
    AppointmentTypeLightResponseFromJSON,
    AppointmentTypeLightResponseFromJSONTyped,
    AppointmentTypeLightResponseToJSON,
    AppointmentTypeLightResponseToJSONTyped,
} from './AppointmentTypeLightResponse';

/**
 * Response for planning by period
 * @export
 * @interface PlanningByPeriodResponse
 */
export interface PlanningByPeriodResponse {
    /**
     * start time of period
     * @type {string}
     * @memberof PlanningByPeriodResponse
     */
    startTime?: string;
    /**
     * end time of period
     * @type {string}
     * @memberof PlanningByPeriodResponse
     */
    endTime?: string;
    /**
     * date
     * @type {string}
     * @memberof PlanningByPeriodResponse
     */
    date?: string;
    /**
     * list of day of week
     * @type {Array<number>}
     * @memberof PlanningByPeriodResponse
     */
    daysOfWeek?: Array<number>;
    /**
     * 
     * @type {AppointmentTypeLightResponse}
     * @memberof PlanningByPeriodResponse
     */
    appointmentType?: AppointmentTypeLightResponse;
}

/**
 * Check if a given object implements the PlanningByPeriodResponse interface.
 */
export function instanceOfPlanningByPeriodResponse(value: object): value is PlanningByPeriodResponse {
    return true;
}

export function PlanningByPeriodResponseFromJSON(json: any): PlanningByPeriodResponse {
    return PlanningByPeriodResponseFromJSONTyped(json, false);
}

export function PlanningByPeriodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanningByPeriodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'date': json['date'] == null ? undefined : json['date'],
        'daysOfWeek': json['daysOfWeek'] == null ? undefined : json['daysOfWeek'],
        'appointmentType': json['appointmentType'] == null ? undefined : AppointmentTypeLightResponseFromJSON(json['appointmentType']),
    };
}

export function PlanningByPeriodResponseToJSON(json: any): PlanningByPeriodResponse {
    return PlanningByPeriodResponseToJSONTyped(json, false);
}

export function PlanningByPeriodResponseToJSONTyped(value?: PlanningByPeriodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'date': value['date'],
        'daysOfWeek': value['daysOfWeek'],
        'appointmentType': AppointmentTypeLightResponseToJSON(value['appointmentType']),
    };
}

